import { PaginatedApiFetcher } from '../../../hooks/useInfiniteDataQuery/utils/useInfiniteDataQueryFn.utils';
import { PaginatedResponse } from '../../../types/request.types';
import { createApiSauceResponse } from './createApiSauceResponse.util';
import {
  AsyncAutocompleteOfflineFetcherRequestParams,
  CreateAsyncAutocompleteOfflineFetcherParams,
} from './createAsyncAutocompleteOfflineFetcher.types';

export const createAsyncAutocompleteOfflineFetcher =
  <T>({
    queryField,
    fetchPage,
  }: CreateAsyncAutocompleteOfflineFetcherParams<T>): PaginatedApiFetcher<T> =>
  async ({ limit, skip, ...params }: AsyncAutocompleteOfflineFetcherRequestParams) => {
    const searchTerm = params[queryField];
    const query = typeof searchTerm === 'string' && searchTerm ? searchTerm : undefined;

    const page = await fetchPage({ limit, skip, query });

    return createApiSauceResponse<PaginatedResponse<T>>({ ok: true, data: page });
  };
